import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  message?: ValidationMessage;
}

export default function required(config: Config = {}): ValidationRule {
  return {
    name: 'required',
    validator(value) {
      return isDefined(typeof value === 'string' ? value.trim() : value);
    },
    message: config.message || t('ll.validation.required'),
  };
}
